
import React from 'react';

const DataProtectionOfficer = () => {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-3">IV. Contact details of the data protection officer (cf. Art. 37 EU-GDPR)</h3>
      <p className="text-gray-600">
        For all questions and as the contact person regarding data protection at our company, our data protection officer is available to you at any time. His contact details are:<br />
        Andreas Schäfer<br />
        Data Protection Officer<br />
        Lange Str. 22, 72379 Hechingen, Germany<br />
        E-Mail: andreas@ai-brainvisuals.com
      </p>
    </div>
  );
};

export default DataProtectionOfficer;
